import { User } from './user';
import { CommodityCategory } from './commodity-category';

export class Commodity {
  name!: string;
  description?: string;
  commodity_category_uuid!: string;
  grade_uuid?: string;
  has_break_number!: boolean;
  break_number?: string;
  stack_footprint?: number;

  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  commodity_category?: CommodityCategory;

  static getSortColumns() {
    return ['name', 'description', 'status'];
  }

  constructor(data: any) {
    this.name = data.name;
    this.description = data.description;
    this.commodity_category_uuid = data.commodity_category_uuid;
    this.grade_uuid = data.grade_uuid;
    this.has_break_number = data.has_break_number;
    this.break_number = data.break_number;
    this.stack_footprint = data.stack_footprint;

    this.status = data.status;
    this.user_uuid = data.user_uuid;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
    if (data.commodity_category) {
      this.commodity_category = new CommodityCategory(data.commodity_category);
    }
  }
}
